/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".iradio_line-red.checked[_ngcontent-%COMP%]   .icheck_line-icon[_ngcontent-%COMP%]{background-color:#01aaad;padding:7px 7px 8px;border-radius:3px;background-position-y:2px}.card[_ngcontent-%COMP%]{background-color:#f2f2f2}"];
export { styles as styles };
